module.exports = __webpack_public_path__ + "img/immiBox_logo.dd666fee.svg";